import { render } from "./cluster.vue?vue&type=template&id=f83692e6"
import script from "./cluster.vue?vue&type=script&lang=js"
export * from "./cluster.vue?vue&type=script&lang=js"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__